<script lang="ts">
  import { Col } from "sveltestrap";
  import { CardContent } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import data from "../../../Data/BonusUi/BonusUi.json"
</script>
{#each data.bordercarddata as borderItem }
    <Col sm="12" xl="6">
        <Card headerTitle={borderItem.title} cardHeaderprops={borderItem.class}>
        <div slot="contentbody">
            <p>{CardContent}</p>
        </div>
        </Card>
    </Col>
{/each}
